<div class="relative group w-[300px] h-[160px] shrink-0">
  <!-- Glowing shadow behind card - solo en pantallas 2xl+ -->
  <div
    class="hidden 2xl:block absolute -inset-2 bg-card-purple-glow/15 blur-[80px] rounded-full opacity-70 group-hover:opacity-100 transition-opacity duration-500 z-0 pointer-events-none"
  ></div>

  <ui-card
    variant="contained"
    color="default"
    rounded="xl"
    padding="none"
    [border]="false"
    minHeight="160px"
    minWidth="300px"
    custom-classes="block relative w-full h-full overflow-hidden backdrop-blur-xl bg-gradient-to-br from-card-purple-from/70 via-card-purple-via/60 to-card-purple-to/70 border border-card-purple-border/40 shadow-card-purple 2xl:shadow-card-2xl hover:shadow-card-purple-hover 2xl:hover:shadow-card-2xl-hover hover:-translate-y-0.5 transition-all duration-300 z-10"
  >
    <!-- Glow -->
    <div
      class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[220px] h-[140px] bg-[radial-gradient(circle,rgba(249,160,27,0.45),transparent_70%)] blur-[80px] opacity-80 pointer-events-none z-0"
    ></div>

    <div class="relative px-3.5 py-2.5 h-full flex flex-col">
      <p class="text-[12px] font-normal text-white">Actividad reciente</p>

      <div class="flex items-center justify-around flex-1 gap-1">
        <!-- Usuarios nuevos -->
        <div class="flex flex-col items-center text-center max-w-[75px]">
          <div
            class="w-8 h-8 rounded-full bg-gradient-to-br from-purple-500 to-purple-600 flex items-center justify-center mb-1.5 shadow-lg"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              stroke-width="2.5"
              stroke-linecap="round"
            >
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
          </div>

          <p class="text-[10px] font-medium text-white leading-tight">
            {{ newUsers }} Usuarios<br />nuevos <br /><span
              class="text-gray-400"
              >en la ultima semana</span
            >
          </p>
        </div>

        <!-- Separador -->
        <div
          class="w-px h-16 bg-gradient-to-b from-transparent via-white/15 to-transparent"
        ></div>

        <!-- Roles modificados -->
        <div class="flex flex-col items-center text-center max-w-[75px]">
          <div
            class="w-8 h-8 rounded-full bg-gradient-to-br from-orange-400 to-orange-500 flex items-center justify-center mb-1.5 shadow-lg"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              stroke-width="2.5"
              stroke-linecap="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
            </svg>
          </div>

          <p class="text-[10px] text-white leading-tight">
            {{ modifiedRoles }} roles<br />modificados<br /><span
              class="text-gray-400"
              >en los últimos 7 días</span
            >
          </p>
        </div>

        <!-- Separador -->
        <div
          class="w-px h-16 bg-gradient-to-b from-transparent via-white/15 to-transparent"
        ></div>

        <!-- Apps registradas -->
        <div class="flex flex-col items-center text-center max-w-[75px]">
          <div
            class="w-8 h-8 rounded-full bg-gradient-to-br from-cyan-400 to-cyan-500 flex items-center justify-center mb-1.5 shadow-lg"
          >
            <svg
              width="15"
              height="15"
              viewBox="0 0 24 24"
              fill="none"
              stroke="white"
              stroke-width="2.5"
              stroke-linecap="round"
            >
              <rect x="4" y="4" width="16" height="16" rx="2"></rect>
              <rect x="9" y="9" width="6" height="6"></rect>
            </svg>
          </div>

          <p class="text-[10px] font-medium text-white leading-tight">
            {{ newApps }} aplicación<br />registrada <br /><span
              class="text-gray-400"
              >recientemente</span
            >
          </p>
        </div>
      </div>
    </div>
  </ui-card>
</div>
